import * as React from 'react';

import { Popover as HeadlessPopover } from '@headlessui/react';

import { clsx } from '@freelancelabs/utils';

import { Popper, PopperPlacement, PopperPosition, usePopper } from '../popper';

export interface PopoverPanelProps {
    anchorRef: React.RefObject<HTMLElement | null>;
    anchorPosition?: PopperPosition | null;
    originalPlacement?: PopperPlacement;
    isOpen?: boolean;
    children:
        | React.ReactNode
        | ((bag: {
              open: boolean;
              close: (focusableElement?: HTMLElement | React.MutableRefObject<HTMLElement | null>) => void;
          }) => React.ReactElement<any, string | React.JSXElementConstructor<any>>);
}
function PopoverPanel({
    anchorRef,
    children,
    anchorPosition,
    originalPlacement = 'bottom',
    isOpen = false,
    ...rest
}: PopoverPanelProps) {
    const { floating, position, placement } = usePopper({
        reference:
            anchorPosition || anchorPosition === null
                ? {
                      mode: 'position',
                      value: anchorPosition,
                      anchor: anchorRef.current,
                  }
                : {
                      mode: 'element',
                      value: anchorRef.current,
                  },
        isOpen,
        originalPlacement,
    });
    return (
        <>
            {isOpen && (
                <Popper
                    isOpen
                    divRef={floating}
                    style={{ ...position }}
                    className={clsx('popover', `popover--${placement}`)}
                    role="dialog"
                    {...rest}
                >
                    <HeadlessPopover.Panel focus={true} className="popover-panel">
                        {children}
                    </HeadlessPopover.Panel>
                </Popper>
            )}
        </>
    );
}

export default PopoverPanel;
